import { Datos_proyecto } from './../../../models/datos_proyecto.model';
import { Component, ViewChild, ElementRef } from "@angular/core";
import {  FormControl, FormGroup, Validators } from '@angular/forms';
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-datos_proyecto",
    templateUrl: "./datos_proyecto.component.html"
})

export class Datos_proyectoComponent {
    @ViewChild('openModal') openModal:ElementRef;
      public rows = [];
      public actualRow;
      public datos_proyecto: Datos_proyecto;
      public form;
      public temp_dproy;

    constructor(){

        this.form = new FormGroup({
            datos: new FormControl('', Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("datos_proyecto"))){
            localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("datos_proyecto"));

            this.form.controls['datos'].setValue(this.rows[0]?this.rows[0].datos:false);
        }
     

    }

    add_datos_proyecto(){
        this.actualRow = localStorage.getItem("datos_proyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            datos: this.form.value.datos
        })
        localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
    }
    delete_datos_proyecto(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
            }
        }
    }

}